import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { capitalize } from '@mui/material';
import { Link } from 'react-router-dom';
import { SendPostRequest } from '../../http';
import HeaderWrapper from '../Header/HeaderWrapper';
import TextMainBannerWrapper from '../TextMainBanners/TextMainBannerWrapper';
import Spinner from '../Spinner';
import FooterWrapper from '../Footer/FooterWrapper';

function MasonryGutterGallery() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Controlled heights (300px, 350px, 400px)
  const getRowHeight = (index) => {
    const heights = [300, 350, 400];
    return heights[index % 3];
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getGalleryData();
  }, []);

  const getGalleryData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest('gallery/list');
      setGalleryData(response?.data || []);
    } catch (error) {
      console.error('Error fetching gallery data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Gallery" Image="theme-2-banner-gallery.webp" />

      <section className="portfolio-section">
        <h2 className="screen-reader-text">Project</h2>
        <div className="container">
          <div className="row">
            <div className="col-12">
              {loading ? (
                <div className="text-center py-5">
                  <Spinner />
                </div>
              ) : galleryData.length > 0 ? (
                <div className="portfolio-grid">
                  <div className="row g-2"> {/* Reduced gap with g-2 */}
                    {galleryData.map((item, index) => (
                      <div className="col-md-4 col-sm-6" key={item.uid || index}>
                        <div className="portfolio-item">
                          <div
                            className="portfolio-thumb gallery-mobile-view-overlay" 
                            style={{ height: `${getRowHeight(index)}px` }}
                          >
                            <Link
                              to={`/gallery/${item?.uid || index}`}
                            >
                              <img
                                src={item.gallery_image}
                                className="img-fluid w-100 h-100"
                                alt={item.title || 'Gallery Item'}
                                style={{
                                  objectFit: 'cover',
                                  objectPosition: 'center'
                                }}
                              />
                            </Link>
                            <div className="portfolio-overlay">
                              <Link
                                to={`/gallery/${item?.uid || index}`}
                                className="portfolio-link"
                              >
                                <i className="icon-link tex-white" style={{ color: "#FFF" }}></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <h3>No Record Available</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <FooterWrapper />
    </div>
  );
}

export default MasonryGutterGallery;